module.exports = __webpack_public_path__ + "img/support.522ac9a.svg";